/**
 * Sprint 42 — Lógica pura para decidir qué variante visual mostrar
 * en la pantalla "Cerrar Día". Extraída para testabilidad.
 *
 *  - `cerrado`: la dueña ya apretó "Cerrar día completo" (existe marca
 *    persistente `dia_cerrado_YYYY-MM-DD` en ConfiguracionSistema).
 *  - `en_proceso`: hay marca null PERO al menos un paso ya está hecho
 *    (caja cerrada, propinas repartidas, o inventario cerrado).
 *  - `inicial`: ningún paso completado y sin marca.
 */

export type VarianteDia = 'inicial' | 'en_proceso' | 'cerrado';

export interface EntradaCalculoVariante {
  /** Marca persistente en ConfiguracionSistema (null si no existe). */
  diaCerradoMarca: { fechaCierre: string } | null;
  /** ¿La caja está cerrada (Corte.fechaCierre != null)? */
  cajaCerrada: boolean;
  /** ¿No quedan propinas pendientes en el pozo? */
  propinasRepartidas: boolean;
  /** ¿Existe un CierreDia para hoy? */
  inventarioCerrado: boolean;
}

export function calcularVariante(e: EntradaCalculoVariante): VarianteDia {
  if (e.diaCerradoMarca) return 'cerrado';
  const algunHecho = e.cajaCerrada || e.propinasRepartidas || e.inventarioCerrado;
  return algunHecho ? 'en_proceso' : 'inicial';
}
